import React from 'react';

import { IBadgeListFields } from '../../../types/contentful';

import { Badge } from './Badge';
import { BlockContainer, Layout, Column } from '../Layout';
import { Text } from '../Text';

import { Wrapper, BadgeColumn } from './styles';

interface Props extends IBadgeListFields {
  sysId?: string;
}

export function BadgeList({ badges, heading, sysId }: Props) {
  return (
    <BlockContainer
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-eltype="badge-list"
      data-blockid={sysId}
      data-testid="badgeList"
    >
      <Layout>
        {!!heading && (
          <Column size={{ 0: 10 }} marginBottom="ml" justifyContent="center">
            <Text
              as="h2"
              fontSize={{
                0: 'h2_0',
                tablet: 'h2_tablet',
                desktop: 'h2_desktop'
              }}
              fontWeight="h2"
              colour="defaultText"
              textAlign="center"
              data-elementid="badge-list-heading"
              dangerouslySetInnerHTML={{
                __html: heading || ''
              }}
            />
          </Column>
        )}
        <BadgeColumn
          size={{ 0: 12, tablet: 11, max: 10 }}
          flexDirection="column"
        >
          <Wrapper>
            {(badges || []).map(({ fields }, index) => (
              <Badge key={index} {...fields} />
            ))}
          </Wrapper>
        </BadgeColumn>
      </Layout>
    </BlockContainer>
  );
}
